<div class="modal-header">
  <h3 class="modal-title">
    <strong>Atenção!</strong>
  </h3>
</div>

<div class="modal-body text-center">
  <span class="icon warning icone-laranja"></span>
  <h4>Você não enviou o link para <strong>Autenticação do Cliente</strong></h4>
  <h4>
    Com este link, o cliente poderá validar o celular, confirmar as permissões
    de LGPD e SCR e tirar uma foto do seu rosto (selfie).
  </h4>
  <h4>
    Lembre-se que esta etapa é obrigatória e não será possível formalizar a
    proposta sem a autenticação do cliente.
  </h4>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-full-orange" (click)="onClickOk()">
    Ok, entendi
  </button>
</div>
